import React, {Component} from "react";
import Square from "./square";
import './board.css';


class Board extends Component{
    static defaultProps={
        yColumn: 5,
        xRow: 5
    }
    constructor(props){
       super(props);
       this.state= {
           board: this.createBoard(),
           hasWon: false
       };
    }
    createBoard(){
        let board = [];
        for (let y =0; y<this.props.yColumn; y++){
            let row=[];
            for (let x=0; x<this.props.xRow; x++){
                let selColour = (Math.random()<0.5);
                row.push (selColour);
            }
            board.push(row);
        }
        return board;
    }    
    flipCellsAround(keyCode) {
        let { xRow,yColumn } = this.props;
        let board = this.state.board;
        let [y, x] = keyCode.split("-").map(Number);
        function flipCell(y, x) {
            if (x >= 0 && x < xRow && y >= 0 && y < yColumn) {
                board[y][x] = !board[y][x];
            }
        }
        flipCell(y, x);
        flipCell(y, x - 1);
        flipCell(y, x + 1);
        flipCell(y - 1, x);
        flipCell(y + 1, x);
        let hasWon = board.every(row => row.every(selColour => !selColour));
        this.setState({ board: board, hasWon:hasWon });
    }
    makeTable() {
        let tblBoard = [];
        for (let y = 0; y < this.props.yColumn; y++) {
            let row = [];
            for (let x = 0; x < this.props.xRow; x++) {
                let keyCode = `${y}-${x}`;
                row.push(
                    <Square
                    key={keyCode}
                    colour={this.state.board[y][x]}
                    flipCells={() => this.flipCellsAround(keyCode)}
                    />
                );
            }
        tblBoard.push(<tr key={y}>{row}</tr>);
        }
        return (
            <table className='Board'>
            <tbody>{tblBoard}</tbody>
        </table>
        );
    }
    render(){
        if (!this.state.hasWon){
        return( 
            <div className="Board">
                {this.makeTable()}
                <p><br/><br/>Click on Cell to change colour of that cell and its adjacent neighbours (top, bottom, left & right).<br/> Make all cells white to win.</p>
            </div>
        );
        }else {
            return(
            <div className="Board-winner">You Won!!</div>
            )
        }
    }
}

export default Board;
